import React from 'react';
import BoardPresentational from './board-presentatioanl';

const BoardFunctional = () => {
	return <BoardPresentational />;
};

export default BoardFunctional;
